import { useQuery } from '@tanstack/react-query';

const PROJECT_NAME = process.env.REACT_APP_PROJECT || '__PROJECT__';
const SETTINGS_URL = `/branding/ticktime/settings.json`;

export const useAppSettings = () => {
  const settingsQuery = useQuery(
    ['app-settings'],
    async () => {
      const response = await fetch(SETTINGS_URL);
      return response.json();
    },
    { staleTime: Infinity, refetchOnWindowFocus: false }
  );

  return settingsQuery;
};
